export default __webpack_public_path__ + "static/media/gallery-img-3.e85ca62c.png";